export default class CustomerCreateRequest {
  public name: string;
  public email: string;

  constructor(options) {
    this.name = options.name;
    this.email = options.email;
  }
}
